<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              IP Route Information
              <router-link
                :to="{ name: 'NotificationSettingAdd' }"
                class="btn ml-auto"
                v-if="actionCreate"
              >
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">IP Route Information</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(this.pre.ipRouteList) && is_loading == false"
          >
            <div class="btn-toolbar pull-right">
              <el-dropdown
                split-button
                :trigger="'click'"
                @command="handleSelectedRows"
                type="primary"
                v-if="this.selected_row.length"
                class="mr-1"
              >
                {{ this.selected_row.length }}
                {{ "item" | pluralize(this.selected_row.length) }} selected
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="delete"
                    >Delete Selected Items</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>

            <div class="card-tools">
              <!-- <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i> Export
              </button> -->
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="audraname"
                      >Search Item</label
                    >
                    <div class="col-md-9">
                      <div class="input-group">
                        <input
                          type="text"
                          v-model="searchTerm"
                          placeholder="Search by network, protocol, nexthop, distance, etc."
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row">
                <div class="col-md-6">
                  <div class="row justify-content-end">
                    <div class="col-md-9">
                      <button type="submit" class="btn mr-3">
                        <i class="icon-search"></i> Search
                      </button>
                      <button type="reset" class="btn btn-outline" @click="resetFilter()">
                        <i class="icon-refresh"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </form>

          <div class="card-body">
            <div v-if="!_.isEmpty(this.pre.ipRouteList) && is_loading == false">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h6>Total Item: {{ this.displayedNeighbors.length }}</h6>
              </div>
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <!-- <th style="width: 10px">
                      <input type="checkbox" v-model="is_selected_all" @click="selectedRowAll()">
                    </th>
                    <th>ID <sort-icons :_sort="'id'"/></th> -->
                      <th>Network</th>
                      <th>Routing Protocol</th>
                      <th>Next Hop</th>
                      <th>Interface</th>
                      <th>Distance</th>
                      <th>Metric</th>
                      <th>Uptime</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(route, index) in displayedNeighbors" :key="index">
                      <td>{{ route.prefix }}</td>
                      <td>{{ route.protocol }}</td>
                      <td>{{ getNexthops(route.nexthops) }}</td>
                      <td>{{ getInterfaces(route.nexthops) }}</td>
                      <td>{{ route.distance }}</td>
                      <td>{{ route.metric }}</td>
                      <td>{{ route.uptime }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>

            <div
              class="p-4"
              v-if="_.isEmpty(this.pre.ipRouteList) && is_loading == false"
            >
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div
            style="margin-left: 87%"
            class="pagination card-footer pb-3"
            v-if="!_.isEmpty(this.pre.ipRouteList) && is_loading == false"
          >
            <div class="el-pagination is-background">
              <button
                class="pagination-btn btn-prev"
                @click="setPage(currentPage - 1)"
                :disabled="currentPage === 1"
              >
                <i class="el-icon el-icon-arrow-left"></i>
              </button>
              <ul class="el-pager">
                <li
                  v-for="page in totalPages"
                  :key="page"
                  class="pagination-page"
                  :class="{ active: page === currentPage }"
                  @click="setPage(page)"
                >
                  {{ page }}
                </li>
              </ul>
              <button
                class="pagination-btn btn-next"
                @click="setPage(currentPage + 1)"
                :disabled="currentPage === totalPages"
              >
                <i class="el-icon el-icon-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { Notification } from "element-ui";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
// const fileDownload = require("js-file-download");
import { fileDownload } from "@/utils/CommonUtils";

export default {
  name: "IP Route Information",
  metaInfo: {
    title: "IP Route Information | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    searchTerm: "",
    connection: false,
    isfound: 0,
    routeInfo: {},
    actionCreate: false,
    actionView: true,
    actionEdit: true,
    actionDelete: false,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {
      ipRouteList: [],
    },
    currentPage: 1,
    perPage: 10,
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
  }),

  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/notification_settings";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
    displayedNeighbors() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = Math.min(startIndex + this.perPage, this.pre.ipRouteList.length);

      return this.pre.ipRouteList.filter((route) => {
        return (
          route.prefix.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          route.protocol.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          (route.distance && route.distance.toString().includes(this.searchTerm)) ||
          (route.metric && route.metric.toString().includes(this.searchTerm)) ||
          route.uptime.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          (route.nexthops &&
            this.getNexthops(route.nexthops).toString().includes(this.searchTerm)) ||
          (route.nexthops &&
            this.getInterfaces(route.nexthops).toString().includes(this.searchTerm))
        );
      });

      return [];
    },
    totalPages() {
      return Math.ceil(this.displayedNeighbors.length / this.perPage);
    },
  },
  methods: {
    setPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.totalPages) {
        this.currentPage = pageNumber;
      }
    },
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/notification_settings"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      // }

      this.getIPRouteList();
    },
    async getFilterData() {
      this.is_loading = true;

      this.is_loading = false;
    },
    reload: function () {},
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.searchTerm = "";
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    exportFile: function () {
      this.is_loading = true;
      axios
        .get("/notification-settings-export", { responseType: "blob" })
        .then((response) => {
          fileDownload(response.data, "notification_settings.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        });
    },
    selectedRowAll: function () {
      const isSelectedAll = (this.is_selected_all = !this.is_selected_all);
      if (isSelectedAll) {
        var items = [];
        this.list.data.forEach(function (item) {
          items.push(item.id);
        });
        this.selected_row = items;
      } else {
        this.selected_row = [];
      }
    },
    handleSelectedRows(command) {
      if (command === "delete") {
        axios({
          method: "delete",
          url: "/notification_settings/delete-all",
          data: { ids: this.selected_row },
          headers: { "Content-Type": "application/json" },
        })
          .then(function (response) {
            Notification.success({
              title: "Deleted Successfully",
              message: "Data deleted successfully",
              type: "success",
            });
            this.initialize();
          })
          .catch((errors) => {
            if (!_.isEmpty(errors.response) && errors.response.status === 500) {
              this.$toaster.error(errors.response.data.message);
            }
          })
          .finally(() => {
            this.is_selected_all = false;
            this.initialize();
          });
      }
    },
    formatDuration(duration) {
      return duration === null
        ? "N/A"
        : duration / 3600 > 1
        ? duration / 3600 + " hours"
        : duration / 3600 + " hour";
    },
    getIPRouteList: function () {
      const loadingElement = document.getElementById("loading");

      axios
        .post("/add-change-log", {
          syncprocess: "routing_info_sync",
          command: "sh ip route json",
          accountId: LocalStorage.get("accountId"),
        })
        .then((response) => {
          if (response.data === "ok") {
            this.countConnectionCheck = 0;
            this.isfound = 0;
            this.routeInfo = {};

            this.connection = setInterval(() => {
              this.loadRouteInfo();
            }, 4000);
          } else {
            this.is_loading = false;
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          this.is_loading = false;
        });
    },

    loadRouteInfo() {
      axios
        .post("/load-route-info", {
          accountId: LocalStorage.get("accountId"),
        })
        .then((response) => {
          if (response.data === "not ok" || !response.data) {
            this.isfound = 0;
          } else {
            this.routeInfo = response.data;
            this.isfound = 1;
            clearInterval(this.connection);
            this.parseResponse();
          }
        })
        .catch((error) => {
          console.error("Error loading route info:", error);
        })
        .finally(() => {
          this.countConnectionCheck++;
          if (this.countConnectionCheck >= 15 || this.isfound === 1) {
            clearInterval(this.connection);
            if (this.isfound === 1) {
              this.parseResponse();
            }
            this.is_loading = false;
          }
        });
    },

    parseResponse() {
      try {
        if (!this.routeInfo || !this.routeInfo.data) {
          console.error("No route information available");
          return;
        }

        const responseData = this.routeInfo.data;
        const ipRouteinfoJson = JSON.parse(responseData);
        const routes = [];

        Object.keys(ipRouteinfoJson).forEach((key) => {
          const routeArray = ipRouteinfoJson[key];
          routeArray.forEach((route) => {
            route.nexthops.forEach((nexthop) => {
              if (nexthop.ip) {
                nexthop.ip = nexthop.ip.replace(/\//g, "\\/");
              }
            });
            routes.push(route);
          });
        });

        this.pre.ipRouteList = routes;
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    },

    extractNexthops(nexthops) {
      if (nexthops) {
        const result = [];
        nexthops.forEach((nh) => {
          if (!nh.hasOwnProperty("directlyConnected")) {
            result.push(nh.ip);
          }
        });
        return result.join(", ");
      }
      return "";
    },
    getNexthops(nexthops) {
      if (nexthops) {
        const result = this.extractNexthops(nexthops);
        return result ? result : "DC";
      }
      return "";
    },
    getInterfaces(nexthops) {
      if (nexthops) {
        const interfaces = nexthops.map((nh) => nh.interfaceName);
        return interfaces.join(", ");
      }
      return "";
    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
